module.exports = __webpack_public_path__ + "static/airdrie-logo-440de470bced010b740d35b4c5fd69a9.png";